import React from 'react';
import { NavLink } from 'react-router-dom';
import colors from '../../theme/colors';

const tabs = [
  { to: '/', label: 'Overview' },
  { to: '/batteries', label: 'Batteries' },
  { to: '/inverters', label: 'Inverters' },
  { to: '/chillers', label: 'Chillers' },
  { to: '/dehumidifiers', label: 'Dehumidifiers' },
];

const styles = {
  nav: {
    display: 'flex',
    gap: 0,
    borderBottom: `1px solid ${colors.cardBorder}`,
    background: colors.bg,
    padding: '0 24px',
  },
  link: {
    padding: '10px 20px',
    fontSize: 13,
    fontWeight: 600,
    color: colors.textMuted,
    textDecoration: 'none',
    borderBottom: '2px solid transparent',
    transition: 'color 0.15s, border-color 0.15s',
  },
  activeLink: {
    color: colors.accent,
    borderBottomColor: colors.accent,
  },
};

export default function TabNav() {
  return (
    <nav style={styles.nav}>
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.to === '/'}
          style={({ isActive }) => ({
            ...styles.link,
            ...(isActive ? styles.activeLink : {}),
          })}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
